import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randProductCategory } from '@ngneat/falso'

import type { MockServer } from '../server.js'

export type ConsultationItemSubgroupAttrs = {
  title: string
}

export const model = Model as ModelDefinition<ConsultationItemSubgroupAttrs>

export const factory = Factory.extend<ConsultationItemSubgroupAttrs>({
  title() {
    return randProductCategory()
  },
})

export function seeds(server: MockServer) {
  server.createList('consultationItemSubgroup', 5)
}
